import React, { useState, useEffect } from 'react';
import Logo from '../assets/logo.png';
import { User, X } from 'lucide-react';
import { searchVideosOnly } from '../SearchHelper';
import { useNavigate } from 'react-router-dom';


export default function Header() {
    const navigate = useNavigate();

    const breakpoint = 768;
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);
    const [channels, setChannels] = useState([]);
    const [query, setQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);

    useEffect(() => {
        setIsLoggedIn(!!localStorage.getItem('PK_user'));

        const data = sessionStorage.getItem('PK_Data');
        if (data) {
            const parsed = JSON.parse(data);
            setChannels(parsed.channels || []);
        }

        const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (query.trim()) {
            const results = searchVideosOnly(channels, query.trim());
            setSearchResults(results);
        } else {
            setSearchResults([]); // clear if empty
        }
    }, [query, channels]);

    const handleVideoClick = (video, playlist) => {
        if (!isLoggedIn) {
            const modal = new window.bootstrap.Modal(document.getElementById('loginModal'));
            modal.show();
        } else {
            navigate(`/video`, { state: { video, playlist } });
        }
    };

    const clearInput = () => {
        setQuery('');
        setSearchResults([]);
    }

    const renderDropdown = () => {
        if (query.trim() === '') {
            return (
                <div className="search-dropdown">
                    {channels.map((channel, i) => (
                        <div key={i} className="dropdown-item" onClick={() => window.location.href = `/?channel=${i}`}>
                            <img src={channel.profileImage} alt="" width={40} className="me-2" />

                        </div>
                    ))}
                </div>
            );
        }

        return (
            <div className="search-dropdown">
                {searchResults.length > 0 ? (
                    searchResults.map((video, i) => (
                        <div
                            onClick={() => handleVideoClick(video, video.channel.playlists[0])}
                            key={video.title + Math.random()}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: '0.5rem',
                                cursor: 'pointer',
                            }}
                        >
                            <img className="channel-image" src={video.imageFile} alt={video.title} />
                            <div className="d-flex flex-column align-items-between" style={{ height: '100%' }}>
                                <h6 className="channel-title">{video.title}</h6>
                                <p className="channel-description">{video.description}</p>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="dropdown-item">No videos found.</div>
                )}
            </div>
        );
    };


    useEffect(() => {
        // Set gtranslate settings
        window.gtranslateSettings = {
            default_language: "en",
            languages: ["en", "ar", "pl"],
            wrapper_selector: ".gtranslate_wrapper"
        };

        // Load the dropdown script
        const script = document.createElement('script');
        script.src = "https://cdn.gtranslate.net/widgets/latest/dropdown.js";
        script.defer = true;
        document.body.appendChild(script);

        return () => {
            // Optional cleanup if Header unmounts
            document.body.removeChild(script);
        };
    }, []);


    return (
        <div className="d-flex flex-row justify-content-between w-100 gap-4 position-relative">
            {isMobile ? (
                <img src={Logo} alt="Logo" className="logo py-1" height={40} />
            ) : (
                <div className="position-relative w-50">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Search movies, series, anime etc..."
                        autoComplete="off"
                        name="search_query_input_123"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}

                    />
                    {query && (
                        <button
                            onClick={() => clearInput()}
                            className="clear-button"
                        >
                            clear
                        </button>
                    )}

                    {(channels.length > 0 && query) && renderDropdown()}
                </div>

            )}

            <div className="d-flex flex-row gap-2 w-50 justify-content-end">
                <div className="gtranslate_wrapper"></div>


                <button className="btn btn-secondary" >
                    <a className='text-light' href='https://ma-appsfiles.s3.eu-central-1.amazonaws.com/AE_PaymentPage/index.html?portal=Pikaboo' target='_blank'>Subscribe</a></button>
                {isLoggedIn && !isMobile && (
                    <button className="btn btn-secondary" onClick={() => window.location.href = '/profile'}>
                        <User />
                    </button>
                )}
            </div>
        </div>
    );
}
